import React from 'react'

import { IFormFocusHandle, FormFocusHandleSetter } from './form-focus-handle'

/**
 * Save-site helper: a stable [setter, handleRef] tuple. Pass setter as the
 * FormFocusHandleContext value; call handleRef.current?.focusFirstError() on save failure.
 * The ref lags mount by one microtask (provider publishes in useEffect) — fine, failures
 * come long after mount.
 */
export function useFormFocusHandle(): [FormFocusHandleSetter, React.MutableRefObject<IFormFocusHandle | null>] {
  const ref = React.useRef<IFormFocusHandle | null>(null)
  const setter = React.useCallback<FormFocusHandleSetter>((handle) => {
    ref.current = handle
  }, [])
  return [setter, ref]
}
